import React, { Component } from "react";
import { connect } from "react-redux";
import { updateCategorie, deleteCategorie } from "../actions/categories";
import CategoriesDataService from "../services/categorie.service";
import UploadService from "../services/categorie.service";

class Categorie extends Component {
  constructor(props) {
    super(props);
    this.onChangeNom = this.onChangeNom.bind(this);
    this.getCategorie = this.getCategorie.bind(this);
    this.removeCategorie = this.removeCategorie.bind(this);

    this.state = {
      currentCategorie: {
        id: null,
        Nom: "",
        published:false
      },
      message: "",
      selectedFiles: undefined,
      progress: 0,
      fileInfos: [],
      fileName:"",
    };
  }

  componentDidMount() {
    this.getCategorie(this.props.match.params.id);
  }

  onChangeNom(e) {
    const Nom = e.target.value;

    this.setState(function (prevState) {
      return {
        currentCategorie: {
          ...prevState.currentCategorie,
          Nom: Nom,
        },
      };
    });
  }


  selectFile =(event) =>{
    this.setState({
          selectedFiles: event.target.files,
        }
    );
  }

  upload= () => {



    if (this.state.selectedFiles) {
    let currentFile=this.state.selectedFiles[0];
    let fileName = 'https://api.attirail.fr/api/fichiercategories/files/' + currentFile.name;
    this.setState({
      progress: 0,
      currentFile: currentFile,
    });
    this.setState(function (prevState) {
      return {
        currentCategorie: {
          ...prevState.currentCategorie,
          Img1: fileName,
        },
      };
    });


      UploadService.upload(currentFile, (event) => {
        this.setState({
          progress: Math.round((100 * event.loaded) / event.total),
        });
      }).then((response) => {
        this.setState({
              message: response.data.message,
            }
        );
        return UploadService.getFiles();
      })
          .then((files) => {
            this.setState({
              fileInfos: files.data,
            });
          }).then(() => {
        this.props
            .updateCategorie(this.state.currentCategorie.id, this.state.currentCategorie)
            .then((response) => {
              console.log(response);

              this.setState({message: "La catégorie a été ajoutée"});
            })
            .catch((e) => {
              console.log(e);
            });
      })
          .catch(() => {
            this.setState({
              progress: 0,
              message: "Could not upload the file!",
              currentFile: undefined,
            });
          });


      this.setState({
        selectedFiles: undefined,
      });
    }

    if (!this.state.selectedFiles) {
        this.props
            .updateCategorie(this.state.currentCategorie.id, this.state.currentCategorie)
            .then((reponse) => {
              console.log(reponse);

              this.setState({message: "The categorie was updated successfully!"});
            })
            .catch((e) => {
              console.log(e);
            });
      }

    this.setState(function (prevState) {
      return {
        currentCategorie: {
          ...prevState.currentCategorie,
          published:true,
        },
      };
    })
    }


  getCategorie(id) {
    CategoriesDataService.get(id)
      .then((response) => {
        this.setState({
          currentCategorie: response.data,
        });
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }


  removeCategorie() {
    this.props
      .deleteCategorie(this.state.currentCategorie.id)
      .then(() => {
        this.props.history.push("/categories");
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { currentCategorie , currentFile,progress,
      message} = this.state;

    return (
      <div>
        {currentCategorie ? (
            <div>
              {!currentCategorie.published && (
            <div>
          <div className="edit-form">
            <div>
            <h4>Mise à jour de : {currentCategorie.Nom}</h4>
            <form>
              <div className="form-group">
                <label htmlFor="Nom">Nom</label>
                <input
                    type="text"
                    className="form-control"
                    id="Nom"
                    value={currentCategorie.Nom}
                    onChange={this.onChangeNom}
                />
              </div>
              <div>
                {currentFile && (
                    <div className="progress">
                      <div
                          className="progress-bar progress-bar-info progress-bar-striped"
                          role="progressbar"
                          aria-valuenow={progress}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{width: progress + "%"}}
                      >
                        {progress}%
                      </div>
                    </div>
                )}
                <p>Veuillez ajouter la nouvelle photo</p>
                <label className="btn btn-default">
                  <input type="file" onChange={this.selectFile}/>
                </label>



                <div className="alert alert-light" role="alert">
                  {message}
                </div>


              </div>

              <div className="form-group">
                <label>
                  <strong>Status:</strong>
                </label>
                {currentCategorie.published ? "Published" : "En cours de modification"}
              </div>
            </form>

          </div>

            <button
              className="badge badge-danger mr-2"
              onClick={this.removeCategorie}
            >
              Supprimer
            </button>
            <a
                className="btn badge-success"
                onClick={this.upload}
            >
              Mettre à jour
            </a>
          </div>

            </div>   )}
            {currentCategorie.published===true && (
                <div>
                  <a
                      href="https://gestion.attirail.fr/categories"
                  >
                    Revenir à la liste des catégories
                  </a>

                </div>)}

          </div>

        ) : (
          <div>
            <br />
            <p>Erreur cette catégorie n'éxiste pas</p>
            <a
                href="https://gestion.attirail.fr/categories"
            >
              Revenir à la liste des catégories
            </a>
          </div>
        )
        }
      </div>

    );
  }
}

export default connect(null, { updateCategorie, deleteCategorie })(Categorie);
